const NOTIFICATION_PERMISSION_DENIED_MESSAGE =
  'Notification permission is required for background recording';

interface NotificationPermissionDeniedError extends Error {
  readonly isNotificationPermissionDeniedError: true;
}

const createNotificationPermissionDeniedError = (): NotificationPermissionDeniedError =>
  Object.assign(new Error(NOTIFICATION_PERMISSION_DENIED_MESSAGE), {
    isNotificationPermissionDeniedError: true,
  } as const);

const isNotificationPermissionDeniedError = (
  error: unknown,
): error is NotificationPermissionDeniedError =>
  error instanceof Error &&
  (error as NotificationPermissionDeniedError).isNotificationPermissionDeniedError === true;

const START_CANCELLED_MESSAGE = 'Recording start was cancelled';

interface StartCancelledError extends Error {
  readonly isStartCancelledError: true;
}

const createStartCancelledError = (): StartCancelledError =>
  Object.assign(new Error(START_CANCELLED_MESSAGE), {
    isStartCancelledError: true,
  } as const);

const isStartCancelledError = (error: unknown): error is StartCancelledError =>
  error instanceof Error && (error as StartCancelledError).isStartCancelledError === true;

export {
  createNotificationPermissionDeniedError,
  createStartCancelledError,
  isNotificationPermissionDeniedError,
  isStartCancelledError,
};
